var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluePie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 76,
    viewBox: "0 0 142 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.189 72C141.189 59.7124 137.955 47.6413 131.811 37C125.667 26.3586 116.831 17.522 106.189 11.3782L71.1895 72H141.189Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8105 11.3782C25.1692 17.522 16.3325 26.3586 10.1888 37C4.04498 47.6413 0.810546 59.7124 0.810547 72L70.8105 72L35.8105 11.3782Z",
    fill: "#EEEEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.677 11.8782L107.177 11.0122L106.311 10.5122C95.5172 4.28064 83.2737 0.999999 70.8105 1C58.3474 1 46.1039 4.28065 35.3105 10.5122L34.4445 11.0122L34.9445 11.8782L69.9445 72.5L70.8106 74L71.6766 72.5L106.677 11.8782Z",
    fill: "#437AF8",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.189 72C107.189 62.4522 103.397 53.2955 96.6453 46.5442C89.894 39.7928 80.7373 36 71.1895 36C61.6417 36 52.4849 39.7928 45.7336 46.5442C38.9823 53.2955 35.1895 62.4522 35.1895 72L107.189 72Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePie);
export default __webpack_public_path__ + "static/media/bluePie.44d57ea931692166d93bb35929429200.svg";
export { ForwardRef as ReactComponent };